import * as React from 'react';
import { DateTime } from 'luxon';
import pluralize from 'pluralize';
import { Container } from 'types/Watchlist';
import { DATE_FORMATS } from 'utils/container-transforms';
import { DualCell } from './DualCell';
import { CellProps } from './types';

export const EstPerDiemLFD: React.FC<CellProps> = (props) => {
  const container: Container = props.row;

  let topText = '';
  let bottomText: React.ReactNode = '';

  const data = container.latestPerDiemCalculation;
  if (data) {
    if (data.estLfd) {
      topText = DateTime.fromFormat(data.estLfd, DATE_FORMATS.BE_DATE_FORMAT).toFormat(
        DATE_FORMATS.SINGLE_DATE_FORMAT
      );
    }

    if (data.dayCount) {
      const days = data.dayCount;
      const alert = data.dayCount > 0;
      bottomText = days && (
        <span className={`${alert ? 'text-red-900' : ''}`}>
          {days} {pluralize('day', Math.abs(days))}
        </span>
      );
    }
  }

  return <DualCell topText={topText} bottomText={bottomText} showBottomText />;
};
EstPerDiemLFD.displayName = 'ContainerTable.EstPerDiemLFD';
